/* eslint-disable */
// import Bugsnag from "@bugsnag/js";
import * as ElasticAppSearch from "@elastic/app-search-javascript";

// import { isBugsnagEnv } from "@/utils/helpers";
// import SmeetzError from "@/services/smeetz-error.service";

// models
import BookingModel from "../models/BookingModel";
import CustomersModel from "@/app-search/models/CustomersModel";
import { LogService } from "@/services/logging";
import POSConfigModule from "@/store/modules/pos-config";
// import { ProductModel, TicketModel, CustomersModel, BookingModel, BookingStatementModel, TimeSlotModel } from "@/models";

// consts
const DEFAULT_OPTIONS = {
  endpointBase: import.meta.env.VITE_AS_API_URL,
  cacheResponses: false,
};

// enums
export enum EngineTypes {
  // @ts-ignore
  ProductList = import.meta.env.VITE_SEARCH_PRODUCTS,
  // @ts-ignore
  TicketList = import.meta.env.VITE_SEARCH_TICKETS,
  // @ts-ignore
  CustomerList = import.meta.env.VITE_SEARCH_CUSTOMERS,
  // @ts-ignore
  BookingList = import.meta.env.VITE_SEARCH_BOOKING,
  // @ts-ignore
  BookingStatementList = import.meta.env.VITE_SEARCH_BOOKING_STATEMENTS,
  // @ts-ignore
  TimeSlotList = import.meta.env.VITE_SEARCH_TIME_SLOT,
  // @ts-ignore
  WaiverList = import.meta.env.VITE_ELASTIC_WAIVERS,
}

export enum EngineKeys {
  Ticket = "ticket",
  Booking = "booking",
  Product = "product",
  Customer = "customer",
  BookingStatement = "booking_statement",
  TimeSlot = "time_slot",
  Waiver = "waiver",
}

export class RequestAppSearch {
  public service: any;
  public engine: EngineTypes;

  constructor(opts: any) {
    const options = { ...DEFAULT_OPTIONS, ...opts };

    this.engine = opts.engineName;
    this.service = ElasticAppSearch.createClient(options);
  }

  /**
   * Send data
   *
   * @param {any} payload: params for request
   * @returns {Promise<any>}
   */
  public send(payload: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const { query, options } = payload;
      if (
        POSConfigModule.groupId === 1 ||
        POSConfigModule.groupId === 19017 ||
        import.meta.env.VITE_ENV === "test" ||
        import.meta.env.VITE_ENV === "dev"
      ) {
        // Lets add precision parameter to the payload
        // official doc 1: https://www.elastic.co/guide/en/app-search/current/search-api-precision.html
        // official doc 2: https://www.elastic.co/guide/en/app-search/current/precision-tuning.html
        // this will result in showing orders more precisely if you type in Hamza Dahmoun, because Hamza Kahil will have less score
        // This is still in beta version
        // Thread issue: https://smeetz.slack.com/archives/C02NKSQ1031/p1722975636124539
        // released only for Locarno to not change the behaviour for other groups
        options.precision = 4;
      }
      const startTime = Date.now();
      try {
        const response = await this.service.search(query, options);

        const endTime = Date.now();
        const latency = endTime - startTime; // Calculate request time
        LogService.info(
          `Appsearch request for ${this.engine} took ${latency}ms`
        );

        resolve(this.parseData(response));
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Parse response data
   *
   * @param {any} response: data
   * @returns {any}
   */
  private parseData(response: any): any {
    // if (this.engine === EngineTypes.ProductList) {
    //   response.dataModel = response.results.map((item: any) => new ProductModel(item));
    // }

    // if (this.engine === EngineTypes.TicketList) {
    //   response.dataModel = response.results.map((item: any) => new TicketModel(item));
    // }

    if (this.engine === EngineTypes.CustomerList) {
      response.dataModel = response.results.map(
        (item: any) => new CustomersModel(item)
      );
    }

    if (this.engine === EngineTypes.BookingList) {
      response.dataModel = response.results.map(
        (item: any) => new BookingModel(item)
      );
    }

    // if (this.engine === EngineTypes.BookingStatementList) {
    //   response.dataModel = response.results.map((item: any) => new BookingStatementModel(item));
    // }

    // if (this.engine === EngineTypes.TimeSlotList) {
    //   response.dataModel = response.results.map((item: any) => new TimeSlotModel(item));
    // }

    return response;
  }

  /**
   * Error
   *
   * @param {object} error: error
   * @returns {any}
   */
  // private resError(error: Error): any {
  //   const smeetzError = new SmeetzError(error);

  //   if (isBugsnagEnv()) {
  //     Bugsnag.notify(error);
  //   }

  //   return smeetzError;
  // }
}
